import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import TableAHSF from "../../../Components/TableAHSF";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import { GetAllRoundActive } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import { GetCurrentFlow } from "../../../Redux/Reducers/Manager/Dropdowns/GetCurrentFlow";
import { GetAllFieldsManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldsManager";
import { GetAllSubjectManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllSubjectManager";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

const RecommendationsScientificCommitteeAdmin = (props) => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["tasksList"]
  );
  const RoundList = useSelector((state) => state.AllRoundActive.AllRoundActive);
  const FieldsList = useSelector(
    (state) => state.AllFieldsManager.AllFieldsManager
  );
  const SubjectList = useSelector(
    (state) => state.AllSubjectManager.AllSubjectManager
  );
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const [roundId, setRoundId] = useState(null);
  const [FieldId, setFieldId] = useState(null);
  const [SubjectId, setSubjectId] = useState(null);
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "applicantfullName",
      ShowStatus: true,
      NmaeColumn: "الاسم الكامل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل ",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "fieldName",
        keyValueName: "fieldName",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "  الموضوع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "subjectName",
        keyValueName: "subjectName",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "scientificfullName",
      ShowStatus: true,
      NmaeColumn: "اسم عضو الهيئة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "recommindationName",
      ShowStatus: true,
      NmaeColumn: "التوصية",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "note",
      ShowStatus: true,
      NmaeColumn: " الملاحظات",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  useEffect(() => {
    dispatch(GetAllRoundActive());

    dispatch(GetCurrentFlow());
  }, []);

  useEffect(() => {
    dispatch(GetAllFieldsManager({ roundYearId: roundId }));
  }, [roundId]);
  useEffect(() => {
    dispatch(GetAllSubjectManager({ fieldId: FieldId }));
  }, [FieldId]);
  const getCount = async () => {
    if (roundId && FieldId && SubjectId) {
      dispatch(setRefreshTable({ tableId: "subTaskScientific" }));
    }
  };

  useEffect(() => {
    getCount();
  }, [roundId, FieldId, SubjectId]);
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        const result = JSON.parse(e.target.value)?.applicationInformationId;

        console.log(result, "sssswdwdwffefssssdwdwdwdwd");
        window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
            result,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Application Information"
        titleNameAR="معلومات الطلب"
        lang={"ar"}
        titleName="معلومات الطلب"
        child={[
          <div className="form-grid">
            <AllDropDownsAHSF
              fieldsName="Round"
              lang={"ar"}
              show={true}
              disabled={props.disabled}
              yesNo={true}
              dropdownType="normal"
              arrayOoptionList={RoundList}
              KeyText={"roundNameAr"}
              KeyValue={"roundYearId"}
              //   value={applicantInfo?.gender}
              onChange={(e) => {
                setRoundId(e.target.value);
                setFieldId(null);
                setSubjectId(null);
              }}
              //   showValidationMessage={validateList?.includes("roundId")}
              validationMessage={"حقل اجباري"}
            />
            <AllDropDownsAHSF
              fieldsName="field"
              lang={"ar"}
              show={true}
              disabled={props.disabled}
              yesNo={true}
              dropdownType="normal"
              arrayOoptionList={FieldsList}
              KeyText={"fieldNameAr"}
              KeyValue={"fieldId"}
              value={FieldId}
              onChange={(e) => {
                setFieldId(e.target.value);
                setSubjectId(null);
              }}
              //   showValidationMessage={validateList?.includes("FieldId")}
              validationMessage={"حقل اجباري"}
            />
            <AllDropDownsAHSF
              fieldsName="topic"
              lang={"ar"}
              show={true}
              disabled={props.disabled}
              yesNo={true}
              dropdownType="normal"
              arrayOoptionList={SubjectList}
              KeyText={"subjectNameAr"}
              KeyValue={"subjectId"}
              value={SubjectId}
              onChange={(e) => {
                setSubjectId(e.target.value);
              }}
              //   showValidationMessage={validateList?.includes("SubjectId")}
              validationMessage={"حقل اجباري"}
            />

            <div style={{ marginTop: "5px" }}>
              {/* <InputAHSF
                fieldsName="NumberOfRequests"
                show={true}
                lang={"ar"}
                disabled={true}
                value={count}
              /> */}
            </div>
          </div>,
        ]}
      />

      <TableAHSF
        tableId="subTaskScientific"
        culomEdite={culomEdite}
        URL={`api/ScientificCommittee/GetTasksScientificAdmin`}
        UrlBody={{
          roundYearId: roundId,
          fieldId: FieldId,
          subjectId: SubjectId,
        }}
        // mergeColumns={[
        //   "applicationNumber",
        //   "applicantfullName",
        //   "fieldName",
        //   "subjectName",
        // ]}
        // mergeCondition={(row, rowIndex) => rowIndex === 0}
        dataRedux={arrayDataCheckBoks}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />
    </>
  );
};

export default RecommendationsScientificCommitteeAdmin;
